import React from 'react'
import {connect} from 'dva'
import styles from "./index.module.less"
import ticket_guide from "../../assets/ticket_guide.png"
import {Button, Result} from "antd"
import {Link, routerRedux} from 'dva/router'

const Component = ({
                     model,
                     loading,
                     location,
                     dispatch,
                     app,
                   }) => {

  return (
    <div className={styles['page-guide']}>
      <img src={ticket_guide}/>

      <Button type={"primary"} size={"large"} onClick={() => dispatch(routerRedux.replace('/ticket'))}>开始购票</Button>
    </div>
  )
}

export default connect(({app, loading}) => ({
  loading,
  app,
}))(Component)
